import { useEffect, useState } from "react";
import { BlockStack, Button, InlineStack, Text } from "@shopify/polaris";
import {
  queueRequest,
  type QueueAccount,
} from "../../../../packages/shared/shopify-queue/client";
const base = import.meta.env.VITE_API_URL || "https://api.whenlyapp.com";
type Result = {
  requests: {
    id: string;
    actor_id: string;
    previous_status: string;
    created_at: string;
  }[];
  nextCursor: number | null;
};
export function RetryHistory({
  account,
  id,
}: {
  account: QueueAccount;
  id: string;
}) {
  const [pages, setPages] = useState<number[]>([]),
    [data, setData] = useState<Result | null>(null),
    [error, setError] = useState("");
  const cursor = pages[pages.length - 1];
  useEffect(() => {
    const abort = new AbortController();
    setData(null);
    setError("");
    void queueRequest<Result>(
      base,
      account,
      `/${encodeURIComponent(id)}/retries${cursor ? "?cursor=" + cursor : ""}`,
      { signal: abort.signal },
    )
      .then((value) => {
        if (!abort.signal.aborted) setData(value);
      })
      .catch((e) => {
        if (!abort.signal.aborted) setError(e.message);
      });
    return () => abort.abort();
  }, [account, id, cursor]);
  return (
    <BlockStack gap="200">
      {error && (
        <Text as="p" tone="critical">
          {error}
        </Text>
      )}
      {!data && !error && <Text as="p">Loading retry history…</Text>}
      {data?.requests.map((row) => (
        <Text as="p" key={row.id}>
          Retried {row.previous_status} update on {row.created_at} UTC by staff
          #{row.actor_id}. Receipt {row.id}.
        </Text>
      ))}
      {data && !data.requests.length && (
        <Text as="p">No saved retry requests.</Text>
      )}
      <InlineStack gap="200">
        {pages.length > 0 && (
          <Button onClick={() => setPages((p) => p.slice(0, -1))}>
            Previous retries
          </Button>
        )}
        {data?.nextCursor && (
          <Button onClick={() => setPages((p) => [...p, data.nextCursor!])}>
            Older retries
          </Button>
        )}
      </InlineStack>
    </BlockStack>
  );
}
